export const isNom = (s: string) => {
  return s.endsWith(".nom");
};
